module.exports = __webpack_public_path__ + "img/big-n-salmon.f553984.svg";